import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductCardSkuItemStcokStatusParams {
  distributor_id: number;
  inventory_id: number;
  product_id: number;
  stock_status: string;
}
export class ProductCardSkuItemStockStatusEntity extends BaseEntityClass {
  distributor_id: number;
  inventory_id: number;
  product_id: number;
  stock_status: string;

  constructor(params: ProductCardSkuItemStcokStatusParams) {
    super();
    this.type = "product_card_sku_item_stock_status";
    this.entity_version = 2;
    this.distributor_id = params.distributor_id;
    this.inventory_id = params.inventory_id;
    this.product_id = params.product_id;
    this.stock_status = params.stock_status;
  }
}
